import React from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa'; // install react-icons if not already

const StarRating = ({ rating }) => {
  return (
    <div className="flex items-center space-x-1">
      {[...Array(5)].map((_, i) => {
        const starValue = i + 1;
        if (rating >= starValue) {
          // full star
          return <FaStar key={i} className="text-primary-500" />;
        } else if (rating >= starValue - 0.5) {
          // half star
          return <FaStarHalfAlt key={i} className="text-primary-500" />;
        } else {
          // empty star
          return <FaRegStar key={i} className="text-neutral-300 dark:text-neutral-600" />;
        }
      })}
    </div>
  );
};

export default StarRating;
